import axios from "axios";

export const getEXRApi = async (lang, cookies) => {
    const token = cookies.__t0ken_amar_management;

    let config = {
        method: "get",
        url: `${process.env.REACT_APP_API}/exchange-rates`,
        headers: {
            lan: lang,
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },

        timeout: 15000,
    };

    try {
        const res = await axios(config);
        return { success: res.data.success, res: res };
    } catch (error) {
        return { success: false, res: error };
    }
};


